import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Pill, LayoutDashboard, Shield, LogOut, GraduationCap } from "lucide-react";

export function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  const linkCls = (path) =>
    `text-sm font-medium transition-colors duration-200 ${
      location.pathname === path ? "text-teal-700" : "text-slate-600 hover:text-teal-700"
    }`;

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-white/80 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-2 group">
          <span className="grid place-items-center h-9 w-9 rounded-xl bg-teal-700 text-white shadow-sm group-hover:bg-teal-600 transition-colors duration-200">
            <Pill className="h-5 w-5" />
          </span>
          <span className="font-bold text-lg tracking-tight text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>
            EZ<span className="text-teal-700">Education</span>
          </span>
        </Link>

        <nav className="flex items-center gap-5 sm:gap-7">
          <Link to="/courses" data-testid="navbar-courses-link" className={linkCls("/courses")}>
            Courses
          </Link>
          {user && user.role !== "admin" && (
            <Link to="/dashboard" data-testid="navbar-dashboard-link" className={`hidden sm:inline ${linkCls("/dashboard")}`}>
              Dashboard
            </Link>
          )}
          {user && user.role === "admin" && (
            <Link to="/admin" data-testid="navbar-admin-link" className={`flex items-center gap-1 ${linkCls("/admin")}`}>
              <Shield className="h-4 w-4" /> Admin
            </Link>
          )}

          {user ? (
            <Button data-testid="navbar-auth-button" onClick={handleLogout} variant="outline" size="sm" className="gap-1.5 border-slate-300">
              <LogOut className="h-4 w-4" /> Logout
            </Button>
          ) : (
            <Button data-testid="navbar-auth-button" onClick={() => navigate("/login")} size="sm" className="bg-teal-700 hover:bg-teal-600 text-white gap-1.5">
              <GraduationCap className="h-4 w-4" /> Login
            </Button>
          )}
        </nav>
      </div>
    </header>
  );
}
